import { useDispatch } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { getDepartmentSuccess } from "../../store/slices/TeamManagementSlice";
import { start } from "../../store/slices/GoalsSlice";
// import dateFormate from'dateformat';
// import moment from 'moment';

const DepartmentGoalDetail = ({ rowDataDepartment }) => {

    function formatDate(dateToString) {
        const date = new Date(dateToString);
        const day = date.getDate();
        const monthIndex = date.getMonth().toString();
        const year = date.getFullYear().toString();

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[monthIndex];

        //let hours = date.getHours();
        //let minutes = date.getMinutes();

        // const ampm = hours >= 12 ? 'PM' : 'AM';
        //hours = hours % 12;
        // hours = hours ? hours : 12;
        // minutes = minutes < 10 ? '0' + minutes : minutes;

        const formattedDate = `${day} ${month} ${year}  `;
        return formattedDate;
    }


    const dispatch = useDispatch();
    const { data } = useFetch('departments')
    if (data.results && data.results.length > 0) {
        dispatch(getDepartmentSuccess(data));
    } else (
        dispatch(start())
    )
    return (
        <>
            {
                rowDataDepartment && rowDataDepartment.length > 0 ? (
                    rowDataDepartment.map((curData => {
                        const { id, department_name, created_at, updated_at, target, completed } = curData;

                        return (
                            <tr key={id}>
                                <td>{department_name}</td>
                                <td>{formatDate(created_at)}</td>
                                <td>{updated_at}</td>
                                <td>{completed}%</td>
                                <td>{target}</td>
                            </tr>
                        )
                    }))) : (
                    <span>No department data available.</span>
                )
            }
        </>
    )
}

export default DepartmentGoalDetail;